import React from "react";
import { PrimaryButton } from "office-ui-fabric-react";
import { CardActions, CardContent, CardMedia, Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import { withStyles, WithStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import jwt_decode from "jwt-decode";

import AppVersion from "taskpane/components/Common/AppVersion";
import Label from "taskpane/components/Common/Label";
import Input from "taskpane/components/Common/Input";

import { ErrorMessage } from "constants/common-messages";
import { HttpStatusCode } from "constants/globals";
import { DECREASING_RED } from "constants/colors";

import { TokenUser } from "apis/models/tokenUser";
import { loginService } from "apis/keycloakApi";

import { getCurrentUser, logoutUser, User } from "utils/user";

import { styles } from "./styles";

import { w3cwebsocket as W3CWebSocket } from "websocket";
import connectTR from "./connectTR";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

const enterKeyValue = 13;
const enterKeyText = "Enter";
var respJsonTemp: any;
var timeOutId: any;
var wsClient: any;
const that = this;
const APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const TYPE_CONNECTION_LS = "lsAddIn";
interface AppProps extends WithStyles<typeof styles> {
  setShowSpinner: (showSpinner: boolean) => void;
  setUser: (user: User) => void;
  setDelay: (bool: boolean) => void;
  handleWsClient: (socket: any) => void;
  logOutUser: () => void;
}
interface AppState {
  userName: string;
  password: string;
  errorMessage: string;
  isChecked: boolean;
  wsClient: Object;
}

class Login extends React.Component<AppProps & WithStyles<typeof styles>, AppState> {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      errorMessage: "",
      isChecked: false,
      wsClient: {},
    };
  }

  handleChangeUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === "userName") {
      this.setState({
        userName: String(value),
      });
    }
  };

  handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === "password") {
      this.setState({
        password: String(value),
      });
    }
  };

  handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === enterKeyText || e.keyCode === enterKeyValue) {
      this.onClickLogin();
    }
  };

  onClickLogin = async () => {
    const that = this;
    const { userName, password } = that.state;
    that.props.setShowSpinner(true);
    try {
      const resp = await loginService(userName, password);
      that.props.setShowSpinner(false);
      const status = resp.status;
      if (status === HttpStatusCode.OK) {
        const respJson: TokenUser = await resp.json();
        const currentTime = Date.now() / 1000;
        const expires_in = currentTime + Number(respJson.expires_in);
        respJsonTemp = { ...respJson, expires_in, userName };

        const decode = jwt_decode(respJsonTemp.access_token);

        try {
          const isDelay = decode["resource_access"]["api-market-data"].roles.includes("BMV_DL");
          this.props.setDelay(isDelay);
        } catch (err) {
          this.props.setDelay(false);
        }

        wsClient = new W3CWebSocket(`${APP_SOCKET_URL || ""}?token=${respJson.access_token}`, "echo-protocol");
        this.setState({
          wsClient,
        });
        timeOutId = setTimeout(() => {
          if (this.state.wsClient) {
            this.state.wsClient["onclose"];
          }
          this.connectSocket();
        }, 31000);

        wsClient = connectTR(
          wsClient,
          respJsonTemp,
          timeOutId,
          TYPE_CONNECTION_LS,
          this.timeOutDisconnect,
          this.connectSocket,
          this.props.logOutUser
        );
        that.props.setUser(respJsonTemp);
        that.props.handleWsClient(wsClient);
      } else {
        that.setState({
          errorMessage: ErrorMessage.AUTHENTICATION_ERROR,
        });
      }
    } catch (error) {
      console.log("error", error);
      that.props.setShowSpinner(false);
      that.setState({
        errorMessage: ErrorMessage.DEFAULT_ERROR,
      });
    }
  };
  logoutUserInternal = () => {
    logoutUser();
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  timeOutDisconnect = () => {
    timeOutId = setTimeout(() => {
      if (this.state.wsClient) {
        this.state.wsClient["onclose"];
      }
      this.connectSocket();
    }, 31000);
  };

  connectSocket() {
    const user = getCurrentUser();
    if (user && respJsonTemp.access_token) {
      wsClient = connectTR(
        wsClient,
        user,
        timeOutId,
        TYPE_CONNECTION_LS,
        this.timeOutDisconnect,
        this.connectSocket,
        this.props.logOutUser
      );
    }
  }

  handleCheckBoxChange = (e) => {
    const val = e.target.checked;

    this.setState({
      isChecked: e.target.checked,
    });
    if (val) {
      const localStorageUSer = {
        userName: this.state.userName,
        password: this.state.password,
        isChecked: e.target.checked,
      };
      localStorage.setItem("user", JSON.stringify(localStorageUSer));
    } else {
      localStorage.clear();
    }
  };

  componentDidMount(): void {
    const localStorageUSer = localStorage.getItem("user");

    if (localStorageUSer) {
      const parsedUserData = JSON.parse(localStorageUSer);
      this.setState({
        userName: parsedUserData.userName,
        password: parsedUserData.password,
        isChecked: parsedUserData.isChecked,
      });
    } else {
      this.setState({
        userName: "",
        password: "",
        isChecked: false,
      });
    }
  }

  render() {
    const { userName, password, errorMessage } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Container fixed className={classes.cardConetent}>
          <CardContent>
            <div className={classes.logo}>
              <CardMedia component="img" alt="logo" image="assets/logo-complete.svg" />
            </div>
            <div style={{ marginTop: 24 }}>
              <span className={classes.loginTextMessage}>¿Ya tienes cuenta? ingresa tus datos</span>
            </div>
          </CardContent>
          <form noValidate autoComplete="off">
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Input
                    id="userName"
                    name="userName"
                    type="text"
                    label="Usuario"
                    value={userName}
                    change={this.handleChangeUserName}
                    onKeyDown={this.handleEnterKey}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    label="Contraseña"
                    value={password}
                    change={this.handleChangePassword}
                    onKeyDown={this.handleEnterKey}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    className={classes.checkBoxLabel}
                    control={
                      <Checkbox
                        className={classes.checkbox}
                        checked={this.state.isChecked}
                        onChange={(e) => this.handleCheckBoxChange(e)}
                        style={{ transform: "scale(0.8)" }}
                        disabled={userName && password ? false : true}
                      />
                    }
                    label={<span style={{ fontSize: "15px" }}>Recordar mis credenciales</span>}
                  />
                </Grid>
                {!!errorMessage && (
                  <Grid item xs={12}>
                    <Label text={errorMessage} color={DECREASING_RED} />
                  </Grid>
                )}
              </Grid>
            </CardContent>
            <CardActions>
              <Grid container direction="row" justify="flex-start" alignItems="center" style={{ marginTop: "0px" }}>
                <PrimaryButton
                  onClick={this.onClickLogin}
                  className={userName && password ? classes.buttonLogin : classes.buttonLoginDisabled}
                  disabled={userName && password ? false : true}
                >
                  <ArrowForwardIosIcon className={classes.forwardIcon} />
                  <span>Iniciar sesi&oacute;n</span>
                </PrimaryButton>
              </Grid>
            </CardActions>
          </form>
          <CardContent className={classes.cardContenteLegends}>
            <div className={classes.containerLegends}>
              <div className={classes.line} />
              <div className={classes.legends}>
                <span>Si a&uacute;n no tienes una cuenta de Hub, ¡Cont&aacute;ctanos! </span>
                <span>
                  <a className={classes.contact} href="mailto:customersuccess@infosel.com" rel="noopener noreferrer">
                    customersuccess@infosel.com
                  </a>
                </span>
                <span>
                  <a className={classes.contact} href="mailto:ventas@infosel.com" rel="noopener noreferrer">
                    ventas@infosel.com
                  </a>
                </span>
                <span>
                  <a className={classes.contact} href="mailto:soporte@infosel.com" rel="noopener noreferrer">
                    soporte@infosel.com
                  </a>
                </span>
                <span>
                  Ciudad de México:{" "}
                  <span className={classes.contact}>
                    <a className={classes.contact} href="#" rel="noopener noreferrer">
                      55 4163 6560
                    </a>
                  </span>
                </span>
                <span>
                  Monterrey:{" "}
                  <span className={classes.contact}>
                    <a className={classes.contact} href="#" rel="noopener noreferrer">
                      81 4170 1678
                    </a>
                  </span>
                </span>
                <span>
                  WhatsApp:{" "}
                  <span className={classes.contact}>
                    <a className={classes.contact} href="#" rel="noopener noreferrer">
                      55 8772 8710
                    </a>
                  </span>
                </span>
              </div>
            </div>
            <div className={classes.appVersion}>
              <AppVersion isLogin={true} />
            </div>
          </CardContent>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(Login);
